import React from "react";
import { Link } from "react-router-dom";

import "./styles/navBar.css";

const NavBar = (props) => {
	const { active } = props;

	return (
		<React.Fragment>
			<div className="nav-container">
				<nav className="navbar">
					<div className="nav-background">
						<ul className="nav-list">
							<li
								className={
									active === "home"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/">Bio</Link>
							</li>
							<li
								className={
									active === "director"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/director">Director</Link>
							</li>
							<li
								className={
									active === "writer"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/writer">Writer</Link>
							</li>
							
							<li
								className={
									active === "actor"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/actor">Actor</Link>
							</li>
							<li
								className={
									active === "producer"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/producer">Producer</Link>
							</li>
							<li
								className={
									active === "editor"
										? "nav-item active"
										: "nav-item"
								}
							>
								<Link to="/editor">Editor</Link>
							</li>
						</ul>
					</div>
				</nav>
			</div>
		</React.Fragment>
	);
};

export default NavBar;
